import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|ECert|Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsCredentialEcertForm';
export type SPCatalogsCredentialEcertFormLocNames =
	| `${LocNameStart}NotificationChangesSaved`
	| `${LocNameStart}LabelFileTemplate`
	| `${LocNameStart}ContentTemplateHint`
	| `${LocNameStart}ErrorFileSize`
	| `${LocNameStart}ErrorFileFormat`
	| `${LocNameStart}LabelCertEnabled`
	| `${LocNameStart}ContentCertEnabledHint`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonUpdate`;

export const spCatalogsCredentialEcertFormLocs: LocDefs<SPCatalogsCredentialEcertFormLocNames> = {
	SPCatalogsCredentialEcertFormNotificationChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Changes saved notification',
		displayPath: `${pathStart}Changes saved`,
		displayType: 'Notification',
		legacyName: 'Credential/CatalogsCredential.Ecert.Notification.ChangesSaved',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormLabelFileTemplate: {
		defaultValue: 'eCertificate Template',
		description: 'Label for: eCertificate Template.',
		displayPath: `${pathStart}eCertificate Template`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldLabel.FileTemplate',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormContentTemplateHint: {
		defaultValue: 'The file must be a .docx format and not exceed 5mb',
		description: 'Hint for: eCertificate Template.',
		displayPath: `${pathStart}eCertificate Template Hint`,
		displayType: 'Content',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldHint.TemplateHint',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormErrorFileSize: {
		defaultValue: 'The file must not exceed 5mb',
		description: 'Error saying the file is too large',
		displayPath: `${pathStart}File too large`,
		displayType: 'Error',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldError.FileSize',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormErrorFileFormat: {
		defaultValue: 'The file must be a .docx format',
		description: 'Error saying the file is the wrong type',
		displayPath: `${pathStart}File wrong type`,
		displayType: 'Error',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldError.FileFormat',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormLabelCertEnabled: {
		defaultValue: 'Certificate Downloads Enabled',
		description: 'Label for: Certificate Downloads Enabled.',
		displayPath: `${pathStart}Certificate Downloads Enabled`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldLabel.CertEnabled',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormContentCertEnabledHint: {
		defaultValue: 'A file must be attached or uploaded before editing',
		description: 'Hint saying a file must be attached or uploaded before editing',
		displayPath: `${pathStart}Credential Enabled Hint`,
		displayType: 'Label',
		legacyName: 'Credential/CatalogsCredential.Ecert.FieldHint.DownloadsHint',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Ecert.Button.Cancel',
		...sharedProperties,
	},
	SPCatalogsCredentialEcertFormButtonUpdate: {
		defaultValue: 'Update',
		description: 'Update button',
		displayPath: `${pathStart}Update`,
		displayType: 'Button',
		legacyName: 'Credential/CatalogsCredential.Ecert.Button.Update',
		...sharedProperties,
	},
};

export type SPCatalogsCredentialEcertFormLocType = LocMap<SPCatalogsCredentialEcertFormLocNames>;
